export function paramCase(str) {
  return str
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '');
}

export function snakeCase(str) {
  return str
    .toLowerCase()
    .replace(/\s+/g, '_')
    .replace(/[^a-z0-9_]/g, '');
}

export function camelCase(str) {
  return str
    .replace(/\s(.)/g, $1 => $1.toUpperCase())
    .replace(/\s/g, '')
    .replace(/^(.)/, $1 => $1.toLowerCase());
}

export function pascalCase(str) {
  return str
    .replace(/\s(.)/g, $1 => $1.toUpperCase())
    .replace(/\s/g, '')
    .replace(/^(.)/, $1 => $1.toUpperCase());
}

export function constantCase(str) {
  return str
    .replace(/\s+/g, '_')
    .replace(/[^A-Z0-9_]/g, '')
    .toUpperCase();
}

export function dotCase(str) {
  return str
    .replace(/\s+/g, '.')
    .replace(/[^a-z0-9.]/g, '');
}

export function pathCase(str) {
  return str
    .replace(/\s+/g, '/')
    .replace(/[^a-z0-9/]/g, '');
}
